import { ComponentChildren } from 'preact';

type ContainerModel = {
  children: ComponentChildren;
  sectionId:string
};

export const Container = ({sectionId, children}: ContainerModel) => (
  <section id={sectionId} class="prompt-container">
    <div class="cm-consent-prompt privacy-prompt">
      <section class="cc-prompt-modal">
          {children}
      </section>
    </div>
  </section>
);
